import { Box, Typography } from "@material-ui/core";

import { useI18nContext } from "@hopper-b2b/i18n";
import { FlightPricingLineItem } from "@hopper-b2b/ui";

import PricingRow from "./PricingRow";

import "./styles.scss";

export interface ITravelerRowProps {
  expanded: boolean;
  pricing: FlightPricingLineItem;
}

const defaultProps: Partial<ITravelerRowProps> = {};

const TravelerRow = (props: ITravelerRowProps): JSX.Element => {
  const { brand, t } = useI18nContext();
  const { expanded, pricing } = props;
  const {
    baseAmount,
    // cfarFee,
    changeFee,
    lineTitle: travelerName,
    taxesAndFees,
  } = pricing;

  return (
    <Box className="traveler-row" key={travelerName}>
      <Typography className="traveler-name" variant="subtitle1">
        {travelerName}
      </Typography>
      {expanded && (
        <>
          {baseAmount ? (
            <PricingRow
              amount={baseAmount}
              currency={brand.currency.code}
              key="base-amount"
              label={t("exchangeable.priceBreakdown.baseFare")}
            />
          ) : null}
          {taxesAndFees ? (
            <PricingRow
              amount={taxesAndFees}
              currency={brand.currency.code}
              key="taxes-and-fees"
              label={t("exchangeable.priceBreakdown.taxes")}
            />
          ) : null}
          {changeFee ? (
            <PricingRow
              amount={changeFee}
              currency={brand.currency.code}
              key="change-fee"
              label={t("exchangeable.priceBreakdown.changeFee")}
            />
          ) : null}
          {/* {cfarFee ? (
            <PricingRow
              amount={cfarFee}
              currency={brand.currency.code}
              key="cfar-fee"
              label={t("exchangeable.priceBreakdown.cfar")}
            />
          ) : null} */}
        </>
      )}
    </Box>
  );
};

TravelerRow.defaultProps = defaultProps;

export default TravelerRow;
